import { Wallet } from 'lucide-react';
import { formatUsd } from '@/lib/utils';

/**
 * Header balance indicator. `balance` is stored as micro-USD (1 unit =
 * $0.000001); formatUsd handles the 6-decimal display.
 */
export function CreditMeter({ balance }: { balance: number }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-muted text-sm">
      <Wallet className="w-4 h-4 text-primary" />
      <span className="font-medium font-mono">{formatUsd(balance)}</span>
    </div>
  );
}
